module.exports = __webpack_public_path__ + "static/media/A_iko_2_strzalka_gora.b438cc9f.svg";